let fallbackSequence = 0;
const issuedIds = new Set<string>();

function fallbackUuid(): string {
  fallbackSequence += 1;
  const bytes = new Uint8Array(16);

  if (typeof globalThis.crypto?.getRandomValues === 'function') {
    globalThis.crypto.getRandomValues(bytes);
  } else {
    const seed = Date.now() + fallbackSequence;
    for (let index = 0; index < bytes.length; index += 1) {
      bytes[index] = (Math.random() * 256 + seed + index * 31) & 0xff;
    }
  }

  bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40;
  bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;
  const hex = [...bytes].map((value) => value.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/** Uses the platform UUID generator and remains usable in older/test runtimes. */
export function createId(): string {
  if (typeof globalThis.crypto?.randomUUID === 'function') {
    const candidate = globalThis.crypto.randomUUID();
    if (!issuedIds.has(candidate)) {
      issuedIds.add(candidate);
      return candidate;
    }
  }
  let candidate = fallbackUuid();
  while (issuedIds.has(candidate)) candidate = fallbackUuid();
  issuedIds.add(candidate);
  return candidate;
}
